import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJuno = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 2C6.26522 2 6.51957 2.10536 6.70711 2.29289L9.70711 5.29289C9.77045 5.35624 9.82352 5.42596 9.86631 5.5H15C17.2091 5.5 19 7.29086 19 9.5V11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19.1805L19.9864 17.8356C19.9954 17.8899 20 17.9449 20 18V21C20 21.5523 19.5523 22 19 22H5C4.44771 22 4 21.5523 4 21V18C4 17.9449 4.00455 17.8899 4.0136 17.8356L4.81954 13H4C3.44771 13 3 12.5523 3 12C3 11.4477 3.44771 11 4 11H5L5 9.5C5 7.85473 5.99333 6.44146 7.41298 5.82719L6 4.41421L5.70711 4.70711C5.31658 5.09763 4.68342 5.09763 4.29289 4.70711L3.29289 3.70711C3.00689 3.42111 2.92134 2.99099 3.07612 2.61732C3.2309 2.24364 3.59554 2 4 2H6ZM7 11H17V9.5C17 8.39543 16.1046 7.5 15 7.5H9C7.89543 7.5 7 8.39543 7 9.5L7 11ZM17.1529 13H6.84713L6.13879 17.25H17.8612L17.1529 13ZM6 20V18.75H18V20H6Z",
		fill: "#646060"
	})
});
export default SvgJuno;
